import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react'

import 'semantic-ui-css/semantic.min.css';
import '../../App.css';

export default class SemanticUiModal extends Component {
 
  render() {
    const { modalOptions, header, content, actions, closeModal } = this.props;

    return (
      <Modal { ...modalOptions } open={ true }>
        <Modal.Header>{ header }</Modal.Header>
        <Modal.Content>{ content }</Modal.Content>
        <Modal.Actions>{ actions }</Modal.Actions>
        <i className="delete icon" onClick={ closeModal }></i>
      </Modal>
    );

  }

}



// WEBPACK FOOTER //
// ./src/components/modal/index.js